import React from 'react'
import '../../pages/Admin/Dashboard/DashboardStyle.css'
import { Link } from 'react-router-dom'
import './CarddsStyle.css'

const CardDs = ({ userimg, imgLoading, starLoading, rating, starimg, name, btn, to }) => {

    const numbers = [1,2,3,4,5];

    return (
        <div className='mainCardDstop'>
            {imgLoading ? imgLoading : <img src={userimg} alt="" className='dscardpImg' />}
            <div className="rating">{rating}</div>
            <div className="ratingWrap">
                {numbers?.map((num, index) => (
                    <React.Fragment key={index}>
                    {num <= (+rating).toFixed(0) ? 
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.36946 1.20194L10.7794 4.02194C10.9694 4.41194 11.4794 4.78194 11.9094 4.86194L14.4595 5.28195C16.0895 5.55195 16.4694 6.73194 15.2994 7.91194L13.3094 9.90194C12.9794 10.2319 12.7895 10.8819 12.8995 11.3519L13.4694 13.8119C13.9194 15.7519 12.8794 16.5119 11.1694 15.4919L8.77943 14.0719C8.34943 13.8119 7.62944 13.8119 7.19944 14.0719L4.80943 15.4919C3.09943 16.5019 2.05944 15.7519 2.50944 13.8119L3.07945 11.3519C3.18945 10.8919 2.99945 10.2419 2.66945 9.90194L0.679455 7.91194C-0.490545 6.74194 -0.110549 5.56195 1.51945 5.28195L4.06944 4.86194C4.49944 4.79194 5.00944 4.41194 5.19944 4.02194L6.60945 1.20194C7.35945 -0.328057 8.59946 -0.328057 9.36946 1.20194Z" fill="#FFCD42" />
                    </svg> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 1.34302L10.163 5.72502L15 6.43202L11.5 9.84101L12.326 14.657L8 12.382L3.674 14.657L4.5 9.84101L1 6.43202L5.837 5.72502L8 1.34302Z" fill="white" stroke="#FFCD42" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>}
                    </React.Fragment>
                ))}
            </div>

            <div className="mentorName">{name}</div>
            <Link className='mentorProfileLink' to={to}>{btn}</Link>
        </div>
    )
}

export default CardDs